import { BasketType } from 'types/basket'

export const FETCH_BASKETS = 'FETCH_BASKETS'
export const fetchBasketsAction = (baskets: BasketType[]) => {
  return {
    type: 'FETCH_BASKETS',
    payload: baskets,
  }
}

export const INIT_BASKETS = 'INIT_BASKETS'
export const initBasketsAction = () => {
  return {
    type: 'INIT_BASKETS',
    payload: null,
  }
}

export const SET_BASKET_UNSUBSCRIBES = 'SET_BASKET_UNSUBSCRIBES'
export const setBasketUnsubscribesAction = (unsubscribes: Array<() => void>) => {
  return {
    type: 'SET_BASKET_UNSUBSCRIBES',
    payload: unsubscribes,
  }
}

export const INIT_BASKET_UNSUBSCRIBES = 'INIT_BASKET_UNSUBSCRIBES'
export const initBasketUnsubscribesAction = () => {
  return {
    type: 'INIT_BASKET_UNSUBSCRIBES',
    payload: undefined,
  }
}
